var map = {
	"./de.ts": [
		2994,
		305
	],
	"./en.ts": [
		1770
	],
	"./es.ts": [
		7029,
		902
	],
	"./fr.ts": [
		9905,
		2
	],
	"./no.ts": [
		7558,
		597
	],
	"./sv.ts": [
		1716,
		775
	],
	"./th.ts": [
		7085,
		566
	],
	"./tt.ts": [
		1641,
		826
	],
	"./zh.ts": [
		4459,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3118;
module.exports = webpackAsyncContext;